import * as Yup from 'yup'

const DownloadParticipantSchema = Yup.object().shape({
  eventId: Yup.string().required('Event is required'),
})

export default DownloadParticipantSchema
